<template>
  <div class="container" :class="{expanded: expandHeader}">
    <div class="subheader" @click="expand">
        <div class="wrapper">
            <div class="main" :style="mainbg">
                <p>{{homeTitle}}</p>
                <template v-if="expandHeader">
                    <div class="up" @click="up">
                        <Icon :fill="'#fff'" :width="'45px'" :height="'45px'" :name="'arr-up'"/>
                    </div>
                    <div class="down" @click="down">
                        <Icon :fill="'#fff'" :width="'45px'" :height="'45px'" :name="'arr-down'"/>
                    </div>
                </template>
            </div
            ><div class="brand">
                <p class="label">Brand</p>
                <p class="text" v-if="!expandHeader">{{cbrand || 'All'}}</p>
                <div class="list" v-else>
                    <p :class="{active: !current_brand}" @click="selectBrand('')">All</p>
                    <p v-for="(brand, index) in brandList" 
                    :key="index"
                    :class="{active: current_brand === brand.url}"
                    @click="selectBrand(brand.url, brand.cname)">{{brand.cname}}</p>
                </div>
            </div
            ><div class="product">
                <p class="label">Product</p>
                <p class="text" v-if="!expandHeader">{{cprod || 'All'}}</p>
                <div class="list" v-else>
                    <p :class="{active: !current_category}" @click="selectProd('')">All</p>
                    <p v-for="(prod, index) in productList" 
                    :key="index"
                    :class="{active: current_category === prod.url}"
                    @click="selectProd(prod.url, prod.cname)">{{prod.cname}}</p>
                </div>
            </div
            ><div class="filter">
                <p class="alph" v-if="!expandHeader">{{currentABC ? currentABC : '-'}}</p>
                <template v-else>
                    <p class="label">Sort by</p>
                    <div class="list">
                        <p :class="{active: !currentABC}" @click="selectABC('')">-</p>
                        <p v-for="(abc, index) in alphabet" 
                        :key="index" 
                        :class="{active: currentABC === abc}"
                        @click="selectABC(abc)">{{abc}}</p>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div class="overlay" @click="collapse"></div>
  </div>
</template>

<script>
import Icon from '@/components/Reusables/Icon'
import {GetProductList} from '@/api/index.js'
export default {
    components: {
        Icon,
    },

    data(){
        return{
            alphabet: [],
            // currentABC: '',

            cbrand: null,
            brandList: null,

            cprod: null,
            productList: null,

            expandHeader: false,
            maintype: 'network',
            url: {
                    network: 'https://cdn.pixabay.com/photo/2016/08/05/16/51/network-1572617_1280.jpg',
                    rfid: 'https://cdn.pixabay.com/photo/2019/07/02/11/51/zutrittskontrolle-4312260_1280.jpg',
                    mining: 'https://cdn.pixabay.com/photo/2018/04/25/07/23/wood-3348867_1280.jpg'
                },
        }
    },

    computed:{
        mainbg(){
            if(this.expandHeader){
                return "backgroundImage: url('" + this.url[this.maintype] + "')"
            }
        },
        current_brand(){
            return this.$route.params.brand
        },
        current_category(){
            return this.$route.params.cat
        },
        currentABC(){
            return this.$store.state.product.alphabet
        },
        homeTitle(){
            if(this.bid == '132'){
                return 'Mining Accessories'
            } else if(this.bid == '133'){
                return 'RFID'
            } else{
                return 'Network Equipment'
            }
        }
    },

    created(){
        this.initData();
        this.genABC();
    },

    methods:{
        expand(){
            if (this.expandHeader) return;
            this.expandHeader = true;
        },
        collapse(){
            if (this.expandHeader) this.expandHeader = false;
        },
        initData(){
            GetProductList({'page_no':1,'sort_field':'price','sort':'asc','keyword':null})
            .then(res =>{
                this.brandList = res.data.brand_list;
                this.productList = res.data.category;
                // console.log(this.bid)
                // console.log(res)
                // console.log(this.productList)
            }).catch(err =>{
                console.log(err)
            })
        },
        genABC(){
            let i = ('A').charCodeAt(0)
            let j = ('Z').charCodeAt(0)
            for(; i <= j; i++){
                this.alphabet.push(String.fromCharCode(i));
            }
        },
        selectABC(p){
            this.goHome()
            this.$store.commit('product/setABC', p);
        },
        selectBrand(p, n = null){
            // this.goHome()
            this.cbrand = n
            if (!p) this.$router.push(`/network`)
            else this.$router.push(`/network/product/${p}`)
            this.$store.commit('product/setBrand', p);
            // this.initData()
        },
        selectProd(p, n = null){
            // this.goHome()
            this.cprod = n
            let brand_url = this.brand
            if (!brand_url && !p) this.$router.push('/network')
            else if (!brand_url) {
                let category_now = this.productList.find(pl => pl.url == p)
                if (!category_now) {
                    window.alert('category error!')
                    return
                }
                let brand_now = this.brandList.find(b => b.cid == category_now.pid)
                brand_url = brand_now.url
            }
            this.$router.push(`/network/product/${brand_url}/${p}`)
            this.$store.commit('product/setProd', p);
        },
        goHome(){
            console.log(this.$route)
            if(this.$route.name != 'home'){
                this.$router.push('/network')
            }
        },
        up(){
            this.goHome()
            if(this.bid == '132'){
                this.$store.commit('product/setBrand', '133')
            }
            else if(this.bid == '133'){
                this.$store.commit('product/setBrand', null)
            } else{
                this.$store.commit('product/setBrand', '132')
            }
        },
        down(){
            this.goHome()
            if(this.bid == '132'){
                this.$store.commit('product/setBrand', null)
            }
            else if(this.bid == '133'){
                this.$store.commit('product/setBrand', '132')
            } else{
                this.$store.commit('product/setBrand', '133')
            }
        }
    },    
};
</script>

<style scoped>
.container{
    width: 100%;
    position: fixed;
    top: 50px;
    left:0;
    color: #353F43;
}
.overlay{
    position: absolute;
    z-index: 100;
    top: 0;
    height: 0;
    width: 100%;
    background: #000;
    opacity: 0;
    transition: opacity .3s ease-in-out;
}
.expanded .overlay{
    opacity: .4;
    height: calc(100vh - 50px);
}

.subheader{
    position: fixed;
    z-index: 101;
    width: 100%;
    height: 65px;
    background: #C4CCCE;
    transition: .3s ease-in-out;
    /* z-index: 102; */
    /* text-align: left; */
}
.subheader:hover{
    background: #a3aaac;
    cursor: pointer;
}
.expanded .subheader{
    height: 240px;
}
.expanded .subheader:hover{
    background: #C4CCCE;
    cursor: default;
}

.wrapper{
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    width: 100%;
}

.main, .product, .brand, .filter{
    display: inline-block;
    vertical-align: middle;
    height: 30px;
}
.main, .product, .brand{
    width: calc(100% / 3 - 30px - 2px);
    border-right: 2px solid #7c868a;
}

/* Expanded State */
.expanded .wrapper{
    height: 100%;
}
.expanded .main, .expanded .product, .expanded .brand, .expanded .filter{
    height: 100%;
}
.expanded .main, .expanded .product, .expanded .brand{
    width: calc(100% / 3 - 30px);
    border: none;
}
.expanded .product, .expanded .brand{
    box-shadow: 8px 0px 10px rgba(0, 0, 0, 0.274);
}
.expanded .product{
    z-index: 101;
}
.expanded .brand{
    z-index: 102;
}
.expanded .main{
    /* background-image: url('./SubHeaderPic/network.jpg'); */
    background-size: cover;
    color: #fff;
}
.expanded .main::before{
    content: "";
    position: absolute;
    left: 0; right: 0;
    top: 0; bottom: 0;
    background: #719192c5;
}

.up, .down{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    opacity: .5;
    transition: .2s ease-in-out;
}
.up{
    top: 0px;
}
.down{
    bottom: 0px;
}
.up:hover, .down:hover{
    cursor: pointer;
    opacity: 1;
}

.main{
    font-size: 26px;
}
.expanded .main{
    position: relative;
}
.expanded .main p{
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.product, .brand{
    position: relative;
}

.label, .text{
    position: absolute;
    top:50%;
}

.label{
    left:40px;
    transform: translateY(-50%);
}
.expanded .label{
    top:0;
    left:50%;
    transform: translateX(-50%);

    background: #719192;
    color: #fff;
    width: 100%;
    line-height: 35px;
}

.text{
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 22px;
}

.filter{
    width: 90px;
    position: relative;
}
.expanded .filter{
    background: #719192;
}
.alph{
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.list{
    position: absolute;
    top:35px;
    width: 100%;
    height: calc(100% - 35px);
    overflow-y: auto;
}

.list::-webkit-scrollbar{
    background-color: none;
    width: 6px;
}
.list::-webkit-scrollbar-thumb{
    background-color: #485053ad;
    border-radius: 20px;
}
.list::-webkit-scrollbar-thumb:hover{
    background-color: #485053;

}

.list p{
    width: 100%;
    line-height: 50px;
    font-size: 20px;
}
.list p:hover, .active{
    cursor: pointer;
    background: #a5bec5;
}

.filter .label{
    color: #353F43;
}
.filter .list p:hover, .filter .active{
    background: #556c6d;
    color: #fff;
}


</style>


// WEBPACK FOOTER //
// src/components/Layouts/SubHeader.vue